import { type IActionOf, type IMapOf } from '../../../../types';
import { Actions } from '../constants';
import { type IAdCreatedPayload, type IAdTrack } from '../types';

export function adStarted(): IActionOf<Actions.AD_STARTED> {
  return { type: Actions.AD_STARTED };
}

export function adEnded(): IActionOf<Actions.AD_ENDED> {
  return { type: Actions.AD_ENDED };
}

export function adSkipped(): IActionOf<Actions.AD_SKIPPED> {
  return { type: Actions.AD_SKIPPED };
}

export function adCreated(
  track: IMapOf<IAdTrack> | IAdTrack,
): IActionOf<Actions.AD_CREATED, IAdCreatedPayload> {
  return {
    type: Actions.AD_CREATED,
    data: { track },
  };
}

export function adDestroyed(): IActionOf<Actions.AD_DESTROYED> {
  return { type: Actions.AD_DESTROYED };
}
